import React from 'react';
import { connect } from 'react-redux';
import { getNodeSeriesStats, getParams, findOccupancyTag, findEfficiencyTag } from 'actions/stats';
import { RECEIVE_FIRST_LOCATION_TOTAL, RECEIVE_SECOND_LOCATION_TOTAL } from 'actions/comparison';
import LineChart from 'components/common/charts/linechart';
import ModeSelector from 'components/common/dropdowncomponents/modeselector';
import TagSelector from 'components/common/dropdowncomponents/tagselector';
//import Modal from "components/common/modal";
export class TotalChart extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'Average',
            tag: 'Occupancy'
        };
    }
    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
    componentWillReceiveProps(nextProps) {
        if (nextProps.isMeetingRoom !== this.props.isMeetingRoom ||
            nextProps.querySettings !== this.props.querySettings) {
            this.setState({
                tag: 'Occupancy'
            })
        }
    }
    getLabels() {
        if (this.props.stats[0].data.constraint.startdate === this.props.stats[0].data.constraint.enddate) {
            return this.props.stats[0].data.points.map((point) => { return point.time.substr(0, 2); });
        }

        else if (this.props.stats[0].data.constraint.groupby === 'month') {
            return this.props.stats[0].data.points.map((point) => { return point.time.substr(0, 8); });
        }
        else {
            return this.props.stats[0].data.points.map((point) => { return point.time.substr(0, 11); });
        }

    }

    getData(index) {
        if (this.props.stats[index]) {
            return this.props.stats[index].data.points.map((point) => { return Math.round(point[this.state.mode === 'Average' ? 'avg' : 'pk'] * 100); });
        }
        else {
            return [];
        }
    }

    chooseMode(mode) {
        this.setState({ mode: mode });
    }

    chooseTag(tag) {

        this.setState({ tag: tag });
        let params = getParams({ querySettings: this.props.querySettings, currentNode: this.props.first });
        params.action = RECEIVE_FIRST_LOCATION_TOTAL;
        let params1 = getParams({ querySettings: this.props.querySettings, currentNode: this.props.second });
        params1.action = RECEIVE_SECOND_LOCATION_TOTAL;
        if (tag === 'Occupancy') {
            params.tag = findOccupancyTag(this.props.first);
            params1.tag = findOccupancyTag(this.props.second);
        }
        else {
            params.tag = findEfficiencyTag(this.props.first);
            params1.tag = findEfficiencyTag(this.props.second);
        }
        this.props.dispatch(getNodeSeriesStats(params));
        this.props.dispatch(getNodeSeriesStats(params1));

    }


    render() {
        let data = {};
        if (this.props.stats) {
            if (this.props.stats.length > 0) {
                data.labels = this.getLabels();
                data.avgs = this.getData(1);
                data.peaks = this.getData(0);
            }
        }
        let first = '';
        let second = '';
        if (this.props.first.info && this.props.first.info) {
            first = this.props.first.info.name;
            second = this.props.second.info.name;
        }
        return (
            <div className="stats-card">
                <div className="card__graph box--shadow bg--white">
                    <div className="clearfix graph__header">
                        <h2 className="graph__header__title graph__header__title--comparison-title pull-left">Total {this.state.tag} Comparison</h2>
                        <div className="graph__header__options pull-right">
                            <div className="header__options__child pull-left"><ModeSelector mode={this.state.mode} chooseMode={this.chooseMode.bind(this)} /></div>
                            {this.props.isMeetingRoom &&
                                <div className="header__options__child pull-left"><TagSelector roomType="meeting_room" tag={this.state.tag} chooseTag={this.chooseTag.bind(this)} /></div>
                            }
                            {/*
                            <Modal
                                disableCloseButton={true}
                                ref={(elem) => { this.openInfoModal = elem }}
                                clickButton={() => { this.openInfoModal.close(); }}
                                header="Info Modal"
                                buttonText="Got it"
                                buttonClass="btn-success"
                                entry={
                                    <div className="header__options__child pull-left">
                                        <div onClick={() => { this.openInfoModal.open() }} className="">
                                            <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                        </div>
                                    </div>
                                }
                            >
                                <p>Total Comparsion Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                            </Modal>
                            */}
                        </div>
                    </div>

                    <div className="graph__body">
                        <LineChart id="totalOccupancy1" stats={data} first={first} second={second} />
                    </div>
                </div >
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(TotalChart);



// WEBPACK FOOTER //
// ./src/components/pages/comparison/charts/totalchart/index.jsx